import React, { useState, useEffect } from 'react';
import { KTSVG, LoadingGrid, SimpleAlert, TableList } from '../../../../../rbts/helpers';
import { useObtenerRecintos } from '../hooks/RecintosHook';
import { ModalCRU } from '../_modals/ModalCRU';
import { MenuComponent } from '../../../../../rbts/assets/ts/components';
import Swal from 'sweetalert2';
import { eliminarRecintoService } from '../../../../service/recintos/Recintos';

const View: React.FC = () => {
  const [reload, setReload] = useState(Math.random() * 40);
  const { list, loading } = useObtenerRecintos(reload);
  const [showModal, setShowModal] = useState(false);
  const [selectedId, setSelectedId] = useState(0);

  const openNew = () => {
    setSelectedId(0);
    setShowModal(true);
  };

  const openEdit = (id: number) => {
    setSelectedId(id);
    setShowModal(true);
  };

  const confirmarEliminar = (id: number, nombre: string) => {
    Swal.fire({
      title: `¿Eliminar "${nombre}"?`,
      text: 'Esta acción no se puede deshacer.',
      icon: 'warning',
      showCancelButton: true,
      cancelButtonText: 'Cancelar',
      confirmButtonText: 'Eliminar',
      reverseButtons: true,
      customClass: { confirmButton: 'btn btn-danger', cancelButton: 'btn btn-light me-3' },
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          await eliminarRecintoService(id);
          setReload(Math.random() * 40);
        } catch (error: any) {
          SimpleAlert(error?.response?.data?.message || 'Error al eliminar el recinto.', 3000, 'error');
        }
      }
    });
  };

  const dropdownRender = (row: any) => (
    <div className="d-flex justify-content-end flex-shrink-0">
      <div
        className="btn btn-light btn-active-light-primary btn-sm"
        data-kt-menu="true"
        data-kt-menu-trigger="click"
        data-kt-menu-placement="bottom-end"
      >
        Acciones
        <span className="svg-icon svg-icon-5 m-0">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M11.4343 12.7344L7.25 8.55005C6.83579 8.13583 6.16421 8.13584 5.75 8.55005C5.33579 8.96426 5.33579 9.63583 5.75 10.05L11.2929 15.5929C11.6834 15.9835 12.3166 15.9835 12.7071 15.5929L18.25 10.05C18.6642 9.63584 18.6642 8.96426 18.25 8.55005C17.8358 8.13584 17.1642 8.13584 16.75 8.55005L12.5657 12.7344C12.2533 13.0468 11.7467 13.0468 11.4343 12.7344Z"
              fill="currentColor"
            />
          </svg>
        </span>
      </div>
      <div className="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-bold fs-7 w-125px py-4" data-kt-menu="true">
        <div className="menu-item px-3">
          <div className="menu-link px-3" onClick={() => openEdit(row.id)}>
            Editar
          </div>
          <div className="menu-link px-3 text-danger" onClick={() => confirmarEliminar(row.id, row.nombre)}>
            Eliminar
          </div>
        </div>
      </div>
    </div>
  );

  const columns: any = [
    {
      id: 'nombre',
      name: <div className="fw-bolder text-muted">Nombre</div>,
      selector: (row: any) => row.nombre,
      cell: (row: any) => <span className="fw-bolder">{row.nombre}</span>,
      sortable: true,
      width: '40%',
    },
    {
      id: 'direccion',
      name: <div className="fw-bolder text-muted">Dirección</div>,
      selector: (row: any) => row.direccion || '—',
      cell: (row: any) => <span>{row.direccion || '—'}</span>,
      sortable: false,
      width: '40%',
    },
    {
      id: 'aforo_max',
      name: <div className="fw-bolder text-muted">Aforo máximo</div>,
      selector: (row: any) => row.aforo_max,
      cell: (row: any) => <span>{Number(row.aforo_max).toLocaleString()}</span>,
      sortable: true,
      width: '10%',
    },
    {
      id: 'acciones',
      name: <div className="fw-bolder text-muted"></div>,
      cell: (row: any) => dropdownRender(row),
      sortable: false,
      width: '10%',
    },
  ];

  useEffect(() => {
    MenuComponent.reinitialization();
  }, [loading]);

  return (
    <>
      <div className="d-flex flex-column flex-xl-row">
        <div className="col-xl-12">
          <div className="flex-lg-row-fluid">
            <div className="card card-xxl-stretch mb-xl-12">
              <div className="card-header border-0 pt-5 mt-4 d-flex">
                <div className="card-title align-items-start flex-column flex-grow-1" />
                <div className="text-end">
                  <button type="button" className="btn btn-primary" onClick={openNew}>
                    <KTSVG path="/media/icons/duotune/arrows/arr075.svg" className="svg-icon-2" />
                    Nuevo recinto
                  </button>
                </div>
              </div>
              <div className="card-body">
                <div className="row gy-5 g-xl-8">
                  <div className="col-xl-12">
                    {loading ? (
                      <LoadingGrid text="Cargando..." />
                    ) : (
                      <TableList data={list} columns={columns} />
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <ModalCRU
        show={showModal}
        handleClose={(refresh) => {
          setShowModal(false);
          setSelectedId(0);
          if (refresh) setReload(Math.random() * 40);
        }}
        id={selectedId}
      />
    </>
  );
};

export { View };
